import React, { useState, useEffect } from 'react';
import './styles/Imageslider.css';
import Guides from './guides/Guides';
import Header from './Content/Header';
import { SliderData } from './SliderData';
import { useStateValue } from '../../services/ContextProvider';


const Imageslilder = ({ viewHeight, TimeInterval }) => {
    //const { globalState } = useStateValue();
    const [current, setcurrent] = useState(0);
    const [previous, setPrevious] = useState(0);
    //const [height, setHeight] = useState("800px");
    const [sliderData, setSilderData] = useState(SliderData);
    const [length, setLength] = useState(sliderData.length);
    const [autoRun, setAutoRun] = useState(true);
    const [intervalFn, setIntervalFn] = useState(null);
    let timeoutHandle;

    useEffect(() => setLength(sliderData.length), [sliderData]);
    //useEffect(() => setSilderData(sliderData), [sliderData]);
    useEffect(() => {
        return () => {
            clearTimeout(intervalFn);
            setIntervalFn(null);
        };
    }, []);

    const nextSlide = () => {
        setPrevious(current);
        setcurrent(current === length - 1 ? 0 : current + 1);
    };

    const changeCurrent = (newCurrent) => {
        setcurrent(newCurrent);
        clearTimeout(timeoutHandle);
        setAutoRun(!autoRun);
    };

    useEffect(() => {
        timeoutHandle = setTimeout(() => {
            nextSlide();
            setAutoRun(!autoRun);
        }, TimeInterval);

        setIntervalFn(timeoutHandle);
    }, [autoRun]);

    if (!Array.isArray(sliderData) || length <= 0) {
        return null;
    }

    //const { imagecarouselState, imagecarouselDispatch } = useStateValue();
    //useEffect(async () => {
    //    if (imagecarouselState.carouselimagelist.length === 0) {
    //        await getCarouselImages(imagecarouselDispatch, imagecarouselState.carouselimagelist);
    //    }
    //}, []);

    //useEffect(() => {
    //    console.log(imagecarouselState);
    //}, [imagecarouselState]);
    const { globalState, globalDispatch } = useStateValue();
    const [carouselArr, setCarouselArr] = useState(globalState.globalCarousel || []);


    //useEffect(() => setCarouselArr(globalState.globalCarousel), [globalState.globalCarousel]);
    useEffect(() => {
        setCarouselArr(globalState.globalCarousel);
        if (globalState.globalCarousel.length > 0) setLength(globalState.globalCarousel.length);
    }, [globalState.globalCarousel]);

    useEffect(() => {
        console.log(carouselArr);
    }, [carouselArr]);

    return (

        <div className={`slider ${viewHeight}`}>

            {carouselArr.map((slide, index) => {
                return (
                    <div className={'slide active'} style={{ position: 'absolute', top: '0', left: '0' }} key={index}>
                        {index === previous && (
                            <img key={slide.image} src={slide.publicUrl} alt="wallpaper" className="image" />
                        )}
                    </div>
                );
            })}
            {carouselArr.map((slide, index) => {
                return (
                    <div className={index === current ? 'slide active' : 'slide'} key={index}>
                        {index === current && (
                            <img key={slide.image} src={slide.publicUrl} alt="wallpaper" className="image" />
                        )}
                    </div>
                );
            })}
            <div className="background-filter"></div>

            <Header />
            <Guides current={current} changeCurrent={changeCurrent} />

        </div>
    );
};

export default Imageslilder;
